import { render, staticRenderFns } from "./Trademark.vue?vue&type=template&id=69f1b741&scoped=true"
import script from "./Trademark.vue?vue&type=script&lang=js"
export * from "./Trademark.vue?vue&type=script&lang=js"
import style0 from "./Trademark.vue?vue&type=style&index=0&id=69f1b741&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f1b741",
  null
  
)

export default component.exports